module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_MakeSameWidth_16"],"path":[{"$":{"d":"M10,5.17l3,3-3,3V9H6v2.17l-3-3,3-3V7h4ZM0,15H2V1H0ZM14,1V15h2V1Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_MakeSameWidth_16.svg
// module id = BQ2H
// module chunks = 1